import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '~utils/helpers';
import DeadlineRelative from './DeadlineRelative';

function StateEarlyVotingDate({ stateData, timePeriod }) {
  let relativeProperty = null;

  if (timePeriod === 'start') {
    relativeProperty = stateData.early_voting_starts;
  } else if (timePeriod === 'end') {
    relativeProperty = stateData.early_voting_ends;
  }

  if (
    relativeProperty &&
    relativeProperty.text.toLowerCase().startsWith('varies')
  ) {
    return <>{capitalize(relativeProperty.text)}</>;
  }

  return <DeadlineRelative relativeDeadline={relativeProperty} />;
}

StateEarlyVotingDate.propTypes = {
  stateData: PropTypes.object.isRequired,
  timePeriod: PropTypes.string.isRequired,
};

export default StateEarlyVotingDate;
